export const OverviewIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H6.875C8.25571 2.5 9.375 3.61929 9.375 5V6.875C9.375 8.25571 8.25571 9.375 6.875 9.375H5C3.61929 9.375 2.5 8.25571 2.5 6.875V5ZM5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V6.875C3.75 7.56536 4.30964 8.125 5 8.125H6.875C7.56536 8.125 8.125 7.56536 8.125 6.875V5C8.125 4.30964 7.56536 3.75 6.875 3.75H5ZM10.625 5C10.625 3.61929 11.7443 2.5 13.125 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V6.875C17.5 8.25571 16.3807 9.375 15 9.375H13.125C11.7443 9.375 10.625 8.25571 10.625 6.875V5ZM13.125 3.75C12.4346 3.75 11.875 4.30964 11.875 5V6.875C11.875 7.56536 12.4346 8.125 13.125 8.125H15C15.6904 8.125 16.25 7.56536 16.25 6.875V5C16.25 4.30964 15.6904 3.75 15 3.75H13.125ZM2.5 13.125C2.5 11.7443 3.61929 10.625 5 10.625H6.875C8.25571 10.625 9.375 11.7443 9.375 13.125V15C9.375 16.3807 8.25571 17.5 6.875 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V13.125ZM5 11.875C4.30964 11.875 3.75 12.4346 3.75 13.125V15C3.75 15.6904 4.30964 16.25 5 16.25H6.875C7.56536 16.25 8.125 15.6904 8.125 15V13.125C8.125 12.4346 7.56536 11.875 6.875 11.875H5ZM10.625 13.125C10.625 11.7443 11.7443 10.625 13.125 10.625H15C16.3807 10.625 17.5 11.7443 17.5 13.125V15C17.5 16.3807 16.3807 17.5 15 17.5H13.125C11.7443 17.5 10.625 16.3807 10.625 15V13.125ZM13.125 11.875C12.4346 11.875 11.875 12.4346 11.875 13.125V15C11.875 15.6904 12.4346 16.25 13.125 16.25H15C15.6904 16.25 16.25 15.6904 16.25 15V13.125C16.25 12.4346 15.6904 11.875 15 11.875H13.125Z"
      fill="currentColor"
    />
  </svg>
);

export const PositionsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M5.35714 8.125L1.875 10L5.35714 11.875M5.35714 8.125L10 10.625L14.6429 8.125M5.35714 8.125L1.875 6.25L10 1.875L18.125 6.25L14.6429 8.125M14.6429 8.125L18.125 10L14.6429 11.875M14.6429 11.875L18.125 13.75L10 18.125L1.875 13.75L5.35714 11.875M14.6429 11.875L10 14.375L5.35714 11.875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const OrdersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
    <rect
      x="1.5"
      y="1"
      width="13"
      height="15"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path d="M4.75 5H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M4.75 10H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const TradeHistoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V15C17.5 16.3807 16.3807 17.5 15 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5ZM5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V15C3.75 15.6904 4.30964 16.25 5 16.25H15C15.6904 16.25 16.25 15.6904 16.25 15V5C16.25 4.30964 15.6904 3.75 15 3.75H5ZM13.75 5.625C14.0952 5.625 14.375 5.90482 14.375 6.25V13.75C14.375 14.0952 14.0952 14.375 13.75 14.375C13.4048 14.375 13.125 14.0952 13.125 13.75V6.25C13.125 5.90482 13.4048 5.625 13.75 5.625ZM11.25 7.5C11.5952 7.5 11.875 7.77982 11.875 8.125V13.75C11.875 14.0952 11.5952 14.375 11.25 14.375C10.9048 14.375 10.625 14.0952 10.625 13.75V8.125C10.625 7.77982 10.9048 7.5 11.25 7.5ZM8.75 9.375C9.09518 9.375 9.375 9.65482 9.375 10V13.75C9.375 14.0952 9.09518 14.375 8.75 14.375C8.40482 14.375 8.125 14.0952 8.125 13.75V10C8.125 9.65482 8.40482 9.375 8.75 9.375ZM6.25 11.25C6.59518 11.25 6.875 11.5298 6.875 11.875V13.75C6.875 14.0952 6.59518 14.375 6.25 14.375C5.90482 14.375 5.625 14.0952 5.625 13.75V11.875C5.625 11.5298 5.90482 11.25 6.25 11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const FundingHistoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.5C8.44746 2.5 6.91615 2.58982 5.41095 2.76451C4.82444 2.83257 4.375 3.34232 4.375 3.96416V17.2019L6.64288 16.2947C6.79189 16.2351 6.95811 16.2351 7.10712 16.2947L10 17.4519L12.8929 16.2947C13.0419 16.2351 13.2081 16.2351 13.3571 16.2947L15.625 17.2019V3.96416C15.625 3.34232 15.1756 2.83257 14.5891 2.76451C13.0838 2.58982 11.5525 2.5 10 2.5ZM5.26685 1.52284C6.81978 1.34262 8.3992 1.25 10 1.25C11.6008 1.25 13.1802 1.34262 14.7332 1.52284C15.981 1.66766 16.875 2.73935 16.875 3.96416V18.125C16.875 18.3324 16.7721 18.5263 16.6004 18.6425C16.4287 18.7588 16.2104 18.7823 16.0179 18.7053L13.125 17.5481L10.2321 18.7053C10.0831 18.7649 9.91689 18.7649 9.76788 18.7053L6.875 17.5481L3.98212 18.7053C3.78956 18.7823 3.57134 18.7588 3.39961 18.6425C3.22787 18.5263 3.125 18.3324 3.125 18.125V3.96416C3.125 2.73935 4.01903 1.66765 5.26685 1.52284ZM12.0581 6.43306C12.3021 6.18898 12.6979 6.18898 12.9419 6.43306C13.186 6.67714 13.186 7.07286 12.9419 7.31694L7.94194 12.3169C7.69786 12.561 7.30214 12.561 7.05806 12.3169C6.81398 12.0729 6.81398 11.6771 7.05806 11.4331L12.0581 6.43306ZM7.1875 7.5C7.1875 6.98223 7.60723 6.5625 8.125 6.5625C8.64277 6.5625 9.0625 6.98223 9.0625 7.5C9.0625 8.01777 8.64277 8.4375 8.125 8.4375C7.60723 8.4375 7.1875 8.01777 7.1875 7.5ZM10.9375 11.25C10.9375 10.7322 11.3572 10.3125 11.875 10.3125C12.3928 10.3125 12.8125 10.7322 12.8125 11.25C12.8125 11.7678 12.3928 12.1875 11.875 12.1875C11.3572 12.1875 10.9375 11.7678 10.9375 11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const TradingSessionsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M2.55236 7.60209C2.96318 6.16918 3.81094 4.84696 5.0701 3.85263C8.26685 1.32823 12.9048 1.87328 15.4292 5.07004C17.9536 8.2668 17.4085 12.9047 14.2118 15.4291C11.015 17.9535 6.37709 17.4085 3.85269 14.2117C3.31336 13.5287 2.91414 12.78 2.65095 12.0001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.64093 5.54343V9.64086L12.0994 12.0993"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4.1624 7.72776L3.51016 8.12253L2.20566 8.91206L1.41613 7.60757L1.02136 6.95532"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
